import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppStateProvider, useApp } from "@/context/AppState";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Jelajah from "@/pages/Jelajah";
import DestinationDetail from "@/pages/DestinationDetail";
import MochiPage from "@/pages/MochiPage";
import MochiDemo from "@/pages/MochiDemo";
import Hadiah from "@/pages/Hadiah";
import Cerita from "@/pages/Cerita";
import Peringkat from "@/pages/Peringkat";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";

function Splash({ text = "Memuat KencanKita…" }) {
  return (
    <div className="grid min-h-screen place-items-center bg-[#faf8f5]">
      <div className="flex flex-col items-center gap-3">
        <span className="grid h-12 w-12 animate-pulse place-items-center rounded-2xl kk-coral-gradient text-white text-xl font-black">K</span>
        <p className="text-[14px] font-semibold text-[#8a8278]">{text}</p>
      </div>
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Splash />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
  return children;
}

function Shell({ children }) {
  const { loading, state } = useApp();
  if (loading || !state) return <Splash />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/admin/login" element={user && user.role === "admin" ? <Navigate to="/admin" replace /> : <AdminLogin />} />
      <Route path="/admin" element={<AdminOnly><Admin /></AdminOnly>} />
      <Route path="/" element={<Protected><Shell><Jelajah /></Shell></Protected>} />
      <Route path="/destinasi/:id" element={<Protected><Shell><DestinationDetail /></Shell></Protected>} />
      <Route path="/mochi" element={<Protected><Shell><MochiPage /></Shell></Protected>} />
      <Route path="/mochi-demo" element={<Protected><Shell><MochiDemo /></Shell></Protected>} />
      <Route path="/hadiah" element={<Protected><Shell><Hadiah /></Shell></Protected>} />
      <Route path="/peringkat" element={<Protected><Shell><Peringkat /></Shell></Protected>} />
      <Route path="/cerita" element={<Protected><Shell><Cerita /></Shell></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppStateProvider>
            <AppRoutes />
            <Toaster position="top-center" toastOptions={{ style: { fontFamily: "Plus Jakarta Sans, sans-serif" } }} />
          </AppStateProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
